export enum requestStatusEnum {
    INITIAL = 'initial',
    PROGRESS = 'progress',
    SUCCESS = 'success',
    FAILED = 'failed',
  }